// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'

export default class Onboarding extends Component {
  componentDidMount = () => {
    this.props.history.push('/maker')
  }

  render () {
    return <div />
  }
}
